/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    22/07/2018
 */
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '@lemsar/auth/domains/services/auth.service';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/internal/operators';

@Injectable()
export class RegisteredGuard implements CanActivate, CanActivateChild {
    public constructor(public auth: AuthService, public router: Router) {}

    public canActivate(): Observable<boolean> {
        return this.auth.isRegistered().pipe(
            tap((registered: boolean) => {
                if (!registered) {
                    this.router.navigate(['auth', 'register']);
                }
            }),
        );
    }

    public canActivateChild(): Observable<boolean> {
        return this.canActivate();
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/guards/registered.guard.ts